import { render } from "./VideoViewerComp.vue?vue&type=template&id=e297a780"
import script from "./VideoViewerComp.vue?vue&type=script&lang=js"
export * from "./VideoViewerComp.vue?vue&type=script&lang=js"

import "./VideoViewerComp.vue?vue&type=style&index=0&id=e297a780&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__